"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import { Moon, Sun } from "@medusajs/icons"

export const FrontendLanguageSwitcher = () => {
  const { locale, setLocale, t } = useFrontendPreferences()
  const nextLocale = locale === "fa" ? "en" : "fa"
  const nextLabel =
    locale === "fa" ? t.controls.switchToEnglish : t.controls.switchToPersian

  return (
    <button
      type="button"
      className={`sahil-preference-slider sahil-language-switcher ${
        locale === "fa" ? "is-fa" : "is-en"
      }`}
      onClick={() => setLocale(nextLocale)}
      aria-label={nextLabel}
      aria-pressed={locale === "en"}
      dir="ltr"
    >
      <span className="sahil-language-switcher__fa" aria-hidden="true">FA</span>
      <span className="sahil-language-switcher__en" aria-hidden="true">EN</span>
      <span className="sr-only">{nextLabel}</span>
    </button>
  )
}

export const FrontendThemeToggle = () => {
  const { theme, toggleTheme, t } = useFrontendPreferences()
  const nextLabel =
    theme === "light" ? t.controls.switchToDark : t.controls.switchToLight

  return (
    <button
      type="button"
      className={`sahil-preference-slider sahil-theme-toggle ${
        theme === "dark" ? "is-dark" : "is-light"
      }`}
      onClick={toggleTheme}
      aria-label={nextLabel}
      aria-pressed={theme === "dark"}
    >
      <Sun className="sahil-theme-toggle__sun" aria-hidden="true" />
      <Moon className="sahil-theme-toggle__moon" aria-hidden="true" />
      <span className="sr-only">{nextLabel}</span>
    </button>
  )
}
